import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';
import sp from './locales/sp';
import fr from './locales/fr';

const resources = {
    en,
    sp,
    fr
};

i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    keySeparator: '.',
    useSuspense: false,
    interpolation: {
        escapeValue: false,
    },
    fallbackLng: 'en',
});

export default i18n;
